import { TransformPlainObject } from './transform.plainObject';
import { ColumnPlainObject } from './column.plainObject';

export class ExtendPlainObject extends TransformPlainObject {
    public columns: ColumnPlainObject[] = [];
}
